import React, { useState } from 'react';
import { FaChevronDown } from "react-icons/fa";
import { Menu, MenuButton, MenuItem, MenuItems, Transition } from '@headlessui/react';
import { FiMapPin } from "react-icons/fi";
import { HiArrowUp, HiArrowDown } from "react-icons/hi";
import { Link } from 'react-router-dom';
import { IoBriefcaseOutline } from "react-icons/io5";
import { ApolloConsumer } from '@apollo/client';
import { useModal } from '../Contex.js';
import { toast } from 'react-toastify';
import { LuPlaneTakeoff } from "react-icons/lu";
import { RiRoadMapLine } from "react-icons/ri";
import { IoMdCall, IoMdMail } from "react-icons/io";
import { IoEarth } from "react-icons/io5";
import { FaLocationDot } from "react-icons/fa6";

function classNames(...classes) {
    return classes.filter(Boolean).join(' ');
}


const countries = [
    { name: "Australia" },
    { name: "Albania" },
    { name: "Algeria" },
    { name: "Andorra" },
    { name: "Angola" },
    { name: "Antigua and Barbuda" },
    { name: "Argentina" },
    { name: "Armenia" },
    { name: "Afghanistan" },
    { name: "Austria" },
    { name: "Azerbaijan" },
    { name: "Bahamas" },
    { name: "Bahrain" },
    { name: "Bangladesh" },
    { name: "Barbados" },
    { name: "Belarus" },
    { name: "Belgium" },
    { name: "Belize" },
    { name: "Benin" },
    { name: "Bhutan" },
    { name: "Bolivia" },
    { name: "Bosnia and Herzegovina" },
    { name: "Botswana" },
    { name: "Brazil" },
    { name: "Brunei" },
    { name: "Bulgaria" },
    { name: "Burkina Faso" },
    { name: "Burundi" },
    { name: "Cabo Verde" },
    { name: "Cambodia" },
    { name: "Cameroon" },
    { name: "Canada" },
    { name: "Central African Rep." },
    { name: "Chad" },
    { name: "Chile" },
    { name: "China" },
    { name: "Colombia" },
    { name: "Comoros" },
    { name: "Congo, Dem. Rep." },
    { name: "Congo, Republic" },
    { name: "Costa Rica" },
    { name: "Croatia" },
    { name: "Cuba" },
    { name: "Cyprus" },
    { name: "Czech Republic" },
    { name: "Denmark" },
    { name: "Djibouti" },
    { name: "Dominica" },
    { name: "Dominican Republic" },
    { name: "Ecuador" },
    { name: "Egypt" },
    { name: "El Salvador" },
    { name: "Equatorial Guinea" },
    { name: "Eritrea" },
    { name: "Estonia" },
    { name: "Eswatini" },
    { name: "Ethiopia" },
    { name: "Fiji" },
    { name: "Finland" },
    { name: "France" },
    { name: "Gabon" },
    { name: "Gambia" },
    { name: "Georgia" },
    { name: "Germany" },
    { name: "Ghana" },
    { name: "Greece" },
    { name: "Grenada" },
    { name: "Guatemala" },
    { name: "Guinea" },
    { name: "Guinea-Bissau" },
    { name: "Guyana" },
    { name: "Haiti" },
    { name: "Honduras" },
    { name: "Hungary" },
    { name: "Iceland" },
    { name: "India" },
    { name: "Indonesia" },
    { name: "Iran" },
    { name: "Iraq" },
    { name: "Ireland" },
    { name: "Israel" },
    { name: "Italy" },
    { name: "Jamaica" },
    { name: "Japan" },
    { name: "Jordan" },
    { name: "Kazakhstan" },
    { name: "Kenya" },
    { name: "Kiribati" },
    { name: "Korea, North" },
    { name: "Korea, South" },
    { name: "Kosovo" },
    { name: "Kuwait" },
    { name: "Kyrgyzstan" },
    { name: "Laos" },
    { name: "Latvia" },
    { name: "Lebanon" },
    { name: "Lesotho" },
    { name: "Liberia" },
    { name: "Libya" },
    { name: "Liechtenstein" },
    { name: "Lithuania" },
    { name: "Luxembourg" },
    { name: "Madagascar" },
    { name: "Malawi" },
    { name: "Malaysia" },
    { name: "Maldives" },
    { name: "Mali" },
    { name: "Malta" },
    { name: "Marshall Islands" },
    { name: "Mauritania" },
    { name: "Mauritius" },
    { name: "Mexico" },
    { name: "Micronesia" },
    { name: "Moldova" },
    { name: "Monaco" },
    { name: "Mongolia" },
    { name: "Montenegro" },
    { name: "Morocco" },
    { name: "Mozambique" },
    { name: "Myanmar" },
    { name: "Namibia" },
    { name: "Nauru" },
    { name: "Nepal" },
    { name: "Netherlands" },
    { name: "New Zealand" },
    { name: "Nicaragua" },
    { name: "Niger" },
    { name: "Nigeria" },
    { name: "North Macedonia" },
    { name: "Norway" },
    { name: "Oman" },
    { name: "Pakistan" },
    { name: "Palau" },
    { name: "Palestine" },
    { name: "Panama" },
    { name: "Papua New Guinea" },
    { name: "Paraguay" },
    { name: "Peru" },
    { name: "Philippines" },
    { name: "Poland" },
    { name: "Portugal" },
    { name: "Qatar" },
    { name: "Romania" },
    { name: "Russia" },
    { name: "Rwanda" },
    { name: "Saint Kitts and Nevis" },
    { name: "Saint Lucia" },
    { name: "Saint Vincent Grenadines" },
    { name: "Samoa" },
    { name: "San Marino" },
    { name: "Sao Tome and Principe" },
    { name: "Saudi Arabia" },
    { name: "Senegal" },
    { name: "Serbia" },
    { name: "Seychelles" },
    { name: "Sierra Leone" },
    { name: "Singapore" },
    { name: "Slovakia" },
    { name: "Slovenia" },
    { name: "Solomon Islands" },
    { name: "Somalia" },
    { name: "South Africa" },
    { name: "South Sudan" },
    { name: "Spain" },
    { name: "Sri Lanka" },
    { name: "Sudan" },
    { name: "Suriname" },
    { name: "Sweden" },
    { name: "Switzerland" },
    { name: "Syria" },
    { name: "Taiwan" },
    { name: "Tajikistan" },
    { name: "Tanzania" },
    { name: "Thailand" },
    { name: "Timor-Leste" },
    { name: "Togo" },
    { name: "Tonga" },
    { name: "Trinidad and Tobago" },
    { name: "Tunisia" },
    { name: "Turkey" },
    { name: "Turkmenistan" },
    { name: "Tuvalu" },
    { name: "Uganda" },
    { name: "Ukraine" },
    { name: "United Arab Emirates" },
    { name: "United Kingdom" },
    { name: "United States" },
    { name: "Uruguay" },
    { name: "Uzbekistan" },
    { name: "Vanuatu" },
    { name: "Vatican City" },
    { name: "Venezuela" },
    { name: "Vietnam" },
    { name: "Yemen" },
    { name: "Zambia" },
    { name: "Zimbabwe" }
];

const gujaratDistrictsTalukasTowns = [
    { district: 'Ahmedabad', talukas: ['Ahmedabad', 'Daskroi', 'Detroj-Rampura', 'Dhandhuka', 'Dholka', 'Mandal', 'Sanand', 'Viramgam', 'Bavla', 'Dholka Rural', 'Ranpur', 'Barwala'], towns: ['Ahmedabad', 'Sanand', 'Dholka', 'Viramgam', 'Dhandhuka', 'Bavla'] },
    { district: 'Amreli', talukas: ['Amreli', 'Bagasara', 'Dhari', 'Jafrabad', 'Khambha', 'Lathi', 'Liliya', 'Savarkundla', 'Rajula', 'Babra', 'Kukavav'], towns: ['Amreli', 'Savarkundla', 'Rajula', 'Bagasara', 'Dhari', 'Lathi'] },
    { district: 'Anand', talukas: ['Anand', 'Anklav', 'Petlad', 'Sojitra', 'Umreth', 'Khambhat', 'Borsad', 'Tarapur'], towns: ['Anand', 'Nadiad', 'Petlad', 'Khambhat', 'Borsad', 'Umreth'] },
    { district: 'Arvalli', talukas: ['Arvalli', 'Bayad', 'Bhiloda', 'Idar', 'Khedbrahma', 'Modasa', 'Meghraj', 'Dhansor', 'Sevalia'], towns: ['Modasa', 'Idar', 'Khedbrahma', 'Bayad', 'Meghraj'] },
    { district: 'Banaskantha', talukas: ['Banaskantha', 'Deesa', 'Palanpur', 'Danta', 'Dantiwada', 'Vadgam', 'Amirgadh', 'Deodar', 'Lakhani'], towns: ['Palanpur', 'Deesa', 'Abu Road', 'Amirgadh', 'Danta'] },
    { district: 'Bhavnagar', talukas: ['Bhavnagar', 'Gariadhar', 'Ghogha', 'Jesar', 'Mahuva', 'Palitana', 'Sihor', 'Talaja', 'Umrala', 'Vallabhipur', 'Gadhada'], towns: ['Bhavnagar', 'Sihor', 'Mahuva', 'Palitana', 'Gadhada', 'Botad'] },
    { district: 'Bharuch', talukas: ['Bharuch', 'Ankleshwar', 'Hansot', 'Jambusar', 'Jhagadia', 'Netrang', 'Valia'], towns: ['Bharuch', 'Ankleshwar', 'Jambusar', 'Hansot', 'Dahej'] },
    { district: 'Botad', talukas: ['Botad', 'Gadhada', 'Lathi', 'Umrala', 'Vallabhipur'], towns: ['Botad', 'Gadhada', 'Lathi'] },
    { district: 'Chhotaudepur', talukas: ['Chhota Udaipur', 'Jetpur Pavi', 'Kawant', 'Nasvadi', 'Sankheda', 'Tilakwadi'], towns: ['Chhota Udaipur', 'Jetpur Pavi', 'Kawant', 'Nasvadi'] },
    { district: 'Dahod', talukas: ['Dahod', 'Devgadbaria', 'Dhanpur', 'Fatepura', 'Garbada', 'Jhalod', 'Limkheda', 'Limdi', 'Randhiya'], towns: ['Dahod', 'Jhalod', 'Limkheda', 'Devgadbaria'] },
    { district: 'Devbhoomi Dwarka', talukas: ['Devbhoomi Dwarka', 'Dwarka', 'Jamkhambhaliya', 'Kalyanpur', 'Khambhalia', 'Kalavad', 'Bhanvad'], towns: ['Jamnagar', 'Dwarka', 'Khambhalia', 'Mithapur'] },
    { district: 'Dang', talukas: ['Dang', 'Ahwa', 'Subir'], towns: ['Ahwa', 'Waghai'] },
    { district: 'Gandhinagar', talukas: ['Gandhinagar', 'Mansa', 'Kalol', 'Dahegam', 'Infocity'], towns: ['Gandhinagar', 'Kalol', 'Mansa', 'Dahegam'] },
    { district: 'Gir-Somnath', talukas: ['Gir-Somnath', 'Girinagar', 'Kodinar', 'Maliya-Hatina', 'Mangrol', 'Somnath', 'Talala', 'Una', 'Sutrapada'], towns: ['Veraval', 'Una', 'Kodinar', 'Mangrol', 'Talala'] },
    { district: 'Jamnagar', talukas: ['Jamnagar', 'Jodiya', 'Kalavad', 'Lalpur', 'Dhrol', 'Bhanvad', 'Khambhalia', 'Jamjodhpur', 'Sikka', 'Paddhari'], towns: ['Jamnagar', 'Dhrol', 'Kalavad', 'Khambhalia'] },
    { district: 'Junagadh', talukas: ['Junagadh', 'Keshod', 'Manavadar', 'Mendarda', 'Una', 'Vanthali', 'Bhesan', 'Malia-Hatina'], towns: ['Junagadh', 'Keshod', 'Una', 'Manavadar', 'Mendarda'] },
    { district: 'Kutch', talukas: ['Kutch', 'Bhuj', 'Anjar', 'Gandhidham', 'Nakhatrana', 'Abdasa', 'Mandvi', 'Mundra', 'Lakhpat', 'Rapar', 'Bhachau'], towns: ['Bhuj', 'Gandhidham', 'Anjar', 'Mandvi', 'Mundra'] },
    { district: 'Kheda', talukas: ['Nadiad', 'Thasra', 'Balasinor', 'Kapadvanj', 'Mehmedabad', 'Dakor', 'Kheda', 'Mahemdavad', 'Matar', 'Petlad', 'Fagvel'], towns: ['Nadiad', 'Anand', 'Petlad', 'Kheda', 'Thasra'] },
    { district: 'Mahisagar', talukas: ['Mahisagar', 'Lunawada', 'Khanpur', 'Balasinor', 'Santram', 'Virpur', 'Virpur East'], towns: ['Lunawada', 'Balasinor', 'Santram'] },
    { district: 'Mehsana', talukas: ['Mehsana', 'Kadi', 'Kalol', 'Vijapur', 'Vadnagar', 'Sidhpur', 'Patan', 'Harij', 'Visnagar'], towns: ['Mehsana', 'Kadi', 'Visnagar', 'Vadnagar', 'Sidhpur'] },
    { district: 'Morbi', talukas: ['Morbi', 'Maliya', 'Tankara', 'Wankaner', 'Halvad'], towns: ['Morbi', 'Wankaner', 'Halvad', 'Maliya'] },
    { district: 'Narmada', talukas: ['Narmada', 'Nandod', 'Dediapada', 'Sagbara', 'Tilakwada'], towns: ['Rajpipla', 'Dediapada', 'Sagbara'] },
    { district: 'Navsari', talukas: ['Navsari', 'Jalalpore', 'Gandevi', 'Chikhli', 'Bansda', 'Khergam'], towns: ['Navsari', 'Bilimora', 'Gandevi', 'Chikhli', 'Bansda'] },
    { district: 'Panchmahal', talukas: ['Panchmahal', 'Godhra', 'Kalol', 'Halol', 'Jambughoda', 'Morva (Hadaf)', 'Shahera', 'Ghoghamba', 'Dehgam'], towns: ['Godhra', 'Halol', 'Kalol', 'Dehgam'] },
    { district: 'Patan', talukas: ['Patan', 'Sidhpur', 'Harij', 'Radhanpur', 'Chanasma', 'Sami', 'Santalpur'], towns: ['Patan', 'Sidhpur', 'Harij', 'Radhanpur'] },
    { district: 'Porbandar', talukas: ['Porbandar', 'Ranavav', 'Kutiyana'], towns: ['Porbandar', 'Ranavav', 'Kutiyana'] },
    { district: 'Rajkot', talukas: ['Rajkot', 'Dhoraji', 'Gondal', 'Jasdan', 'Jetpur', 'Kotda Sangani', 'Lodhika', 'Paddhari', 'Upleta', 'Vinchhiya'], towns: ['Rajkot', 'Gondal', 'Dhoraji', 'Jetpur', 'Upleta'] },
    { district: 'Sabarkantha', talukas: ['Sabarkantha', 'Himatnagar', 'Idar', 'Prantij', 'Talod', 'Vadali', 'Vijaynagar', 'Khedbrahma'], towns: ['Himatnagar', 'Idar', 'Talod', 'Prantij'] },
    { district: 'Surat', talukas: ['Surat', 'Bardoli', 'Chorasi', 'Kamrej', 'Mahuva', 'Mangrol', 'Olpad', 'Palsana', 'Umarpada'], towns: ['Surat', 'Bardoli', 'Kamrej', 'Olpad'] },
    { district: 'Surendranagar', talukas: ['Surendranagar', 'Chotila', 'Dasada', 'Dhrangadhra', 'Lakhtar', 'Limbdi', 'Muli', 'Sayla', 'Thangadh', 'Wadhwan'], towns: ['Surendranagar', 'Dhrangadhra', 'Limbdi', 'Thangadh'] },
    { district: 'Tapi', talukas: ['Tapi', 'Songadh', 'Vyara', 'Uchchhal', 'Nizar', 'Valod'], towns: ['Vyara', 'Songadh', 'Nizar'] },
    { district: 'Vadodara', talukas: ['Vadodara', 'Dabhoi', 'Karjan', 'Padra', 'Savli', 'Sinor', 'Waghodia', 'Nasvadi'], towns: ['Vadodara', 'Dabhoi', 'Padra', 'Karjan'] },
    { district: 'Valsad', talukas: ['Valsad', 'Dharampur', 'Kaprada', 'Pardi', 'Umargam'], towns: ['Valsad', 'Pardi', 'Umargam', 'Vapi'] },
    { district: 'Vav-Tharad', talukas: ['Tharad', 'Vav', 'Bhabhar', 'Deodar', 'Lakhani', 'Suigam'], towns: ['Tharad', 'Vav', 'Bhabhar'] }
];




const Footer = () => {
    const { setModalOpen } = useModal();
    const [showTooltip, setShowTooltip] = useState(false);
    // const currentYear = new Date().getFullYear();
    const token = localStorage.getItem('token');

    const signOut = (client) => {
        localStorage.clear()
        sessionStorage.clear();
        client.resetStore();
        toast.success("user logged out successfully!", {
            autoClose: 2000
        })
    };

    const handleClick = () => {
        setShowTooltip(!showTooltip);
    };

    return (
        <div className='bg-slate-50'>
            <div className="lg:flex lg:items-center lg:justify-between mx-auto max-w-auto px-6 lg:px-8 py-10">
                <div className="min-w-0 flex-1">
                    {/* Logo */}
                    <Link to="/" className="flex items-center ml-4 mb-4 lg:ml-0">
                        <img
                            src="https://algarxpress.s3.ap-south-1.amazonaws.com/AlgarXpressImages/logo1.png"
                            alt="AlgarXpress Logo"
                            className="h-10 w-auto object-contain hidden sm:block"
                        />
                        <div className="flex flex-col ms-2">
                            {/* Main Brand Name */}
                            <p className="text-md font-bold text-slate-800 flex items-center">
                                AlgarXpress
                                <sup className="text-[10px] font-bold text-slate-700">™</sup>
                            </p>

                            {/* Subtitle / Certification */}
                            <p className="text-xs font-semibold text-slate-500 mt-0.5">
                                ISO 9001:2015 Certified Company
                            </p>
                        </div>

                    </Link>
                    <div className="mt-1 flex flex-col sm:mt-0 sm:flex-row sm:flex-wrap sm:space-x-6">
                        <div className="mt-2 flex items-center text-sm text-gray-500 cursor-pointer">
                            <IoBriefcaseOutline className="mr-1.5 h-5 w-5 flex-shrink-0 text-gray-400" aria-hidden="true" />
                            Digital Services
                        </div>
                        <div className="mt-2 flex items-center text-sm text-gray-500 cursor-pointer">
                            <FiMapPin className="mr-1.5 h-5 w-5 flex-shrink-0 text-gray-400" aria-hidden="true" />
                            Mumbai (Maharashtra)
                        </div>
                        <div className="mt-2 flex items-center text-sm text-gray-500 cursor-pointer">
                            <HiArrowUp className="mr-1.5 h-5 w-5 flex-shrink-0 text-gray-400" aria-hidden="true" />
                            Free Pick-up at your doorstep
                        </div>
                        <div className="mt-2 flex items-center text-sm text-gray-500 cursor-pointer">
                            <HiArrowDown className="mr-1.5 h-5 w-5 flex-shrink-0 text-gray-400" aria-hidden="true" />
                            Delivery at your doorstep
                        </div>
                    </div>
                </div>
                <div className="mt-5 flex lg:ml-4 lg:mt-0">
                    <span className="hidden sm:block">
                        <Link to="/accordionhelp">
                            <button
                                type="button"
                                className="inline-flex items-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-slate-50"
                            >
                                Help
                            </button>
                        </Link>
                    </span>
                    <span className="ml-3 hidden sm:block">
                        <Link to="/allorders">
                            <button
                                type="button"
                                className="inline-flex items-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-slate-50"
                            >
                                All Shipment
                            </button></Link>
                    </span>
                    <span className="sm:ml-3">
                        <Link to="/documentshipping">
                            <button
                                type="button"
                                className="inline-flex items-center rounded-md bg-slate-900 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-black focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                            >
                                Shipment Now
                            </button></Link>
                    </span>
                    <Menu as="div" className="relative ml-3 sm:hidden">
                        <MenuButton className="inline-flex items-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:ring-gray-400">
                            More
                            <FaChevronDown className="-mr-1 ml-1.5 h-5 w-5 text-gray-400" aria-hidden="true" />
                        </MenuButton>
                        <Transition
                            enter="transition ease-out duration-200"
                            enterFrom="transform opacity-0 scale-95"
                            enterTo="transform opacity-100 scale-100"
                            leave="transition ease-in duration-75"
                            leaveFrom="transform opacity-100 scale-100"
                            leaveTo="transform opacity-0 scale-95"
                        >
                            <MenuItems className="absolute right-0 z-10 -mr-1 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                                <MenuItem>
                                    {({ active }) => (
                                        <Link
                                            to="/allorders"
                                            className={classNames(active ? 'bg-slate-100' : '', 'block px-4 py-2 text-sm text-gray-700')}
                                        >
                                            All Shipment
                                        </Link>
                                    )}
                                </MenuItem>
                                <MenuItem>
                                    {({ active }) => (
                                        <Link
                                            to="/accordionhelp"
                                            className={classNames(active ? 'bg-slate-100' : '', 'block px-4 py-2 text-sm text-gray-700')}
                                        >
                                            Help
                                        </Link>
                                    )}
                                </MenuItem>
                            </MenuItems>
                        </Transition>
                    </Menu>
                </div>
            </div>
            <div className='mx-auto max-w-auto px-6 lg:px-8 pt-1 pb-10'>
                <div className='grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-x-6 pb-10 gap-y-10 text-sm'>
                    <ul className='mt-6 space-y-6 sm:mt-4 sm:space-y-4'>
                        <li className='font-medium text-gray-900'>Ship now</li>
                        <li className='hover:text-gray-800 text-gray-500'><Link to='/documentshipping' state={{ key: false }}>Express Document Shipping</Link></li>
                        <li className='hover:text-gray-800 text-gray-500'><Link to='/documentshipping' state={{ key: true }}>Lightweight Parcel Shipping</Link></li>
                        {/* <li className='hover:text-gray-800 text-gray-500'><Link to='/bulkcourier'>Bulk Shipping (0-30Kg)</Link></li> */}
                        {/* <li className='hover:text-gray-800 text-gray-500'><Link to='/sameday'>Same day Shipment</Link></li> */}
                        {/* <li className='hover:text-gray-800 text-gray-500'><Link to='/foreignair'>Worldwide (Global) Shipping</Link></li> */}
                    </ul>
                    <ul className='mt-6 space-y-6 sm:mt-4 sm:space-y-4'>
                        <li className='font-medium text-gray-900'>Get Shipment Estimate</li>
                        <li className='hover:text-gray-800 text-gray-500'><Link to='/calculatorcourier' state={{ keyy: false }}>Document Delivery Estimate</Link></li>
                        <li className='hover:text-gray-800 text-gray-500'><Link to='/calculatorcourier' state={{ keyy: true }}>Parcel Delivery Estimate</Link></li>
                        {/* <li className='hover:text-gray-800 text-gray-500'><Link to='/bulkcourier'>Bulk Shipping (0-30Kg)</Link></li> */}
                        {/* <li className='hover:text-gray-800 text-gray-500'><Link to='/sameday'>Same day Shipment</Link></li> */}
                        {/* <li className='hover:text-gray-800 text-gray-500'><Link to='/foreignair'>Worldwide (Global) Shipping</Link></li> */}
                    </ul>
                    <ul className='mt-6 space-y-6 sm:mt-4 sm:space-y-4'>
                        <li className='font-medium text-gray-900'>Domestic Shipping</li>
                        <li className='hover:text-gray-800 text-gray-500'><Link to='/allOrders' state={{ data: 'All Courier' }}>All Domestic Shipments</Link></li>
                        <li className='hover:text-gray-800 text-gray-500'><Link to='/allOrders' state={{ data: 'To me' }}>Incoming Shipments (To Me - Domestic)</Link></li>
                        <li className='hover:text-gray-800 text-gray-500'><Link to='/allOrders' state={{ data: 'From me' }}>Outgoing Shipments (From Me - Domestic)</Link></li>
                        <li className='hover:text-gray-800 text-gray-500'><Link to='/trackcourier'>Track & Locate Shipments</Link></li>
                    </ul>
                    <ul className='mt-6 space-y-6 sm:mt-4 sm:space-y-4'>
                        <li className='font-medium text-gray-900'>Account & Lists</li>

                        <li className='hover:text-gray-800 text-gray-500'>
                            <Link to='/accordionhelp'>Help & Support</Link>
                        </li>

                        {!token && (
                            <>
                                <li className='hover:text-gray-800 text-gray-500'>
                                    <Link to='/signup'>Sign in</Link>
                                </li>
                                <li className='hover:text-gray-800 text-gray-500'>
                                    <Link to='/signup'>Create Account</Link>
                                </li>
                            </>
                        )}

                        {token && (
                            <li className='hover:text-gray-800 text-gray-500'>
                                <ApolloConsumer >
                                    {client => (
                                        <Link to='/signup' onClick={() => signOut(client)} >
                                            Log out
                                        </Link>
                                    )}
                                </ApolloConsumer>
                            </li>
                        )}

                        <li className='hover:text-gray-800 text-gray-500'>
                            <Link to='/packguidlines'>Packaging Standards</Link>
                        </li>
                        <li className='hover:text-gray-800 text-gray-500'>
                            <Link to='/retrictedItem'>Prohibited & Restricted Items</Link>
                        </li>
                    </ul>

                    <ul className='mt-6 space-y-6 sm:mt-4 sm:space-y-4'>
                        <li className='font-medium text-gray-900'>My Activities</li>
                        <li className='hover:text-gray-800 text-gray-500'><Link to='/shippinglabel'>Labeling Instructions</Link></li>
                        <li className='hover:text-gray-800 text-gray-500'><Link to='/anotherhelp'>Contact Us & Enquiry Now</Link></li>
                        <li className='hover:text-gray-800 text-gray-500 cursor-pointer'><Link to='/settings'>Account & Lists</Link></li>
                        <li className='hover:text-gray-800 text-gray-500 cursor-pointer'><Link to='/notification'>Notification</Link></li>
                        <li className='hover:text-gray-800 text-gray-500 cursor-pointer'><Link to='/franchiseeenquiry'>Franchise Enquiry</Link></li>
                    </ul>
                    <ul className='mt-6 space-y-6 sm:mt-4 sm:space-y-4'>
                        <li className='font-medium text-gray-900'>Shipping Policies</li>
                        <li className='hover:text-gray-800 text-gray-500'><Link to='/privacyPolicy'>Privacy Policy</Link></li>
                        <li className='hover:text-gray-800 text-gray-500'><Link to='/termsAndConditions'>Terms & Conditions</Link></li>
                        <li className='hover:text-gray-800 text-gray-500'><Link to='/cookiespolicy'>Cookie Policy</Link></li>
                        <li className='hover:text-gray-800 text-gray-500'><Link to='/fraudDisclaimer'>Fraud Disclaimer</Link></li>
                    </ul>
                </div>
                <p className='font-bold md:mb-2 mb-4'>Our Strong Support : </p>

                <div className='flex flex-col sm:flex-row space-y-6 md:space-y-0 mt-3 mb-7 sm:space-x-6'>
                    <p className='text-sm text-gray-500'>
                        <a href="mailto:algarxpress@gmail.com" className='flex items-center'>
                            <span className='text- font-bold mr-2'>Raise a Query : </span>
                            algarxpress@gmail.com
                        </a>
                    </p>

                    <p className='text-sm text-gray-500'>
                        <a href="tel:+17722444094" className='flex items-center'>
                            <IoEarth className="mr-2 text-xl text-slate-900" />
                            (+1) 772 244 4094 (USA)
                        </a>
                    </p>

                    <p className='text-sm text-gray-500'>
                        <a href="tel:+17722444094" className='flex items-center'>
                            <IoEarth className="mr-2 text-xl text-slate-900" />
                            (+971) 12-345-6466 (Dubai)
                        </a>
                    </p>

                    <p className='text-sm text-gray-500'>
                        <a href="tel:+9102269408494" className='flex items-center'>
                            <IoMdCall className="mr-2 text-xl text-slate-900" />
                            (+91) 022 6962 2461 (Mumbai)
                        </a>
                    </p>

                    {/* <p className='text-sm text-gray-500'>
                        <a href="tel:+917096964646" className='flex items-center'>
                            <IoMdCall className="mr-2 text-xl text-slate-900" />
                            070-9696-4646 (Support)
                        </a>
                    </p> */}

                    {/* <p className='text-sm text-gray-500 '>
                        <a href="tel:+917096964646" className='flex items-center'>
                            <IoMdCall className="mr-2 text-xl text-slate-900" />
                            026 2131 4803 (Enquiry)
                        </a>
                    </p> */}
                </div>


                <div className='mb-10'>
                    <p className='font-bold md:mb-2 mb-4'>Offices : </p>
                    <div className='grid lg:grid-cols-3 md:grid-cols-2 space-y-4 md:space-y-2 text-sm'>
                        <div className='flex cursor-pointer hover:text-blue-600 text-gray-500 items-center space-x-2'>
                            <p className='text-slate-400'><FaLocationDot /></p>
                            <p> International Shipment Office - Surat (Gujarat)</p>
                        </div>
                        {/* <div className='flex cursor-pointer hover:text-blue-600 text-gray-500 items-center space-x-2'>
                            <p className='text-slate-400'><FaLocationDot /></p>
                            <p> International Shipment Office - Ahmedabad (Gujarat)</p>
                        </div> */}
                        <div className='flex cursor-pointer hover:text-blue-600 text-gray-500 items-center space-x-2'>
                            <p className='text-slate-400'><FaLocationDot /></p>
                            <p> International Shipment Office - Mumbai (Maharashtra)</p>
                        </div>
                        <div className='flex cursor-pointer hover:text-blue-600 text-gray-500 items-center space-x-2'>
                            <p className='text-slate-400'><FaLocationDot /></p>
                            <p> International Shipment Office - Pune (Maharashtra)</p>
                        </div>
                        <div className='flex cursor-pointer hover:text-blue-600 text-gray-500 items-center space-x-2'>
                            <p className='text-slate-400'><FaLocationDot /></p>
                            <p> International Shipment Office - Delhi (Delhi)</p>
                        </div>
                        <div className='flex cursor-pointer hover:text-blue-600 text-gray-500 items-center space-x-2'>
                            <p className='text-slate-400'><FaLocationDot /></p>
                            <p> International Shipment Office - Kolkata (West Bengal)</p>
                        </div>
                        <div className='flex cursor-pointer hover:text-blue-600 text-gray-500 items-center space-x-2'>
                            <p className='text-slate-400'><FaLocationDot /></p>
                            <p> International Shipment Office - Chennai (Tamil Nadu)</p>
                        </div>
                        <div className='flex cursor-pointer hover:text-blue-600 text-gray-500 items-center space-x-2'>
                            <p className='text-slate-400'><FaLocationDot /></p>
                            <p> International Shipment Office - Bangalore (Karnataka)</p>
                        </div>
                        <div className='flex cursor-pointer hover:text-blue-600 text-gray-500 items-center space-x-2'>
                            <p className='text-slate-400'><FaLocationDot /></p>
                            <p> International Shipment Office - Hyderabad (Telangana)</p>
                        </div>

                    </div>

                </div>

                {/* <div className='flex'> */}


                <div className=" justify-between ">
                    {/* Left Side: Indian Cities */}
                    {/* <div className="flex-1  ga"> */}
                    <div className="flex mb-2 font-semibold">
                        <LuPlaneTakeoff className="text-2xl mb-2 me-2 text-blue-950" /> {/* Icon for International Courier */}
                        <span>Global Shipment</span>
                    </div>

                    <div className='grid lg:grid-cols-6 md:grid-cols-5 grid-cols-2 space-y-2'>
                        {countries.map((country) => (
                            <Link to='/foreignair' key={country.name}><div

                                className="hover:text-gray-800 text-sm cursor-pointer text-gray-500"
                            >
                                {country.name}
                            </div></Link>
                        ))}
                    </div>
                    <div className="flex mb-2 mt-10 font-semibold">
                        <RiRoadMapLine className="text-2xl mb-2 me-2" /> {/* Icon for Domestic Courier */}
                        <span>India's Shipment</span>
                    </div>

                    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-x-6 gap-y-4">
                        {gujaratDistrictsTalukasTowns.map((district) => (
                            <div key={district.district} className="space-y-10"> {/* vertical gap here */}
                                {district.talukas.map((taluka) => (
                                    <Link to="/documentshipping" key={taluka}>
                                        <p className="text-gray-500 my-2 text-sm hover:text-gray-900 cursor-pointer transition-colors duration-200">
                                            {taluka}
                                        </p>
                                    </Link>
                                ))}
                            </div>
                        ))}
                    </div>




                    {/* </div> */}

                    {/* Right Side: International Countries */}

                </div>
                {/* <div className='flex'>
                        <div className=" grid grid-cols-3 gap-4 ">
                            {countries.map((country, index) => (
                                <div
                                    key={index}
                                    className="hover:text-gray-800 text-sm cursor-pointer text-gray-500"
                                >
                                    {country.name}
                                </div>
                            ))}
                        </div>
                    </div> */}




                {/* </div> */}







                <div className="relative inline-block">
                    <div className='md:flex space-y-6 md:space-y-0 gap-x-6 mt-10 flex-none'>
                        <img src="https://algarxpress.s3.ap-south-1.amazonaws.com/AlgarXpressImages/play1.png" alt="" className='h-16 md:h-14 cursor-pointer' onClick={handleClick} />
                        <img src="https://algarxpress.s3.ap-south-1.amazonaws.com/AlgarXpressImages/applef.png" className='h-16 md:h-14 cursor-pointer' alt="" onClick={handleClick} />
                    </div>
                    {showTooltip && (
                        <div className="absolute mt-4 top-full w-48 bg-slate-800 text-white text-sm rounded-lg shadow-lg p-2">
                            Our application is currently undergoing essential maintenance to bring you new features, improvements, and a better overall experience.
                        </div>
                    )}
                </div>

                <p className='border mt-12'></p>
                <p className='text-md font-semibold text-gray-900 mt-9'>Information Security Policy</p>
                <p className='text-sm mt-1 text-gray-500'>AlgarXpress is committed to safeguarding the confidentiality, integrity and availability of all physical and electronic information assets of the organization.
                    We ensure that the regulatory, operational and contractual requirements are fulfilled.</p>



                {/* <p className='mt-3 text-lg font-bold text-slate-800'><a href="mailto:algarxpress@gmail.com"><span className='text-slate-900 font-bold'>Mail to:</span>algarxpress@gmail.com</a></p> */}
                <p className='text-sm text-gray-500 mt-6'>This website and its content, including text, images, graphics, and other material, are protected by copyright law. Unauthorized use, reproduction, or distribution of this material without prior written permission from AlgarXpress is strictly prohibited.

                </p>
                <p className='text-sm mt-1 text-gray-500'>© {new Date().getFullYear()} AlgarXpress. All rights reserved.</p>


            </div>
        </div>

    );
};

export default Footer;
